import * as React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Datagrid, TextField, useTranslate } from 'react-admin'

import tracker from '../../utils/tracker'
import { CustomDatagridBody } from '../datagrids/customDatagridBody'
import { CustomDatagridRow } from '../datagrids/customDatagridRow'
import { CurrencyField } from '../fields/currencyField'
import { EventPaymentSubTypeField } from '../fields/eventPaymentSubTypeField'
import { EventSubTypeField } from '../fields/eventSubTypeField'
import { LocalDateField } from '../fields/localDateField'
import { ViewInvoicePaymentField } from '../fields/viewInvoicePaymentField'

const useStyles = makeStyles({
  headerRightWithoutIcon: {
    textAlign: 'right',
    paddingRight: '60px',
  },
})

export const EventPaymentList = ({ linkDataInvoices, type, ...props }) => {
  const classes = useStyles()
  const translate = useTranslate()

  const handleViewInvoiceClick = (clickedRecord) => {
    tracker.event({
      action: `${props.resource ?? 'payments'}_details_entry_clicked`,
      category: `${props.resource ?? 'payments'}`,
      label: clickedRecord ? clickedRecord.subType : undefined,
    })
  }

  return (
    <Datagrid
      {...props}
      body={
        <CustomDatagridBody {...props} row={<CustomDatagridRow {...props} />} />
      }
    >
      <ViewInvoicePaymentField
        source="invoiceId"
        label={'resources.creditlines.events.invoice'}
        mode="selectInvoice"
        handleClick={handleViewInvoiceClick}
        emptyMessage={translate('resources.payments.messages.noInvoice')}
      />
      <LocalDateField source="date" label={'resources.payments.events.date'} />
      {type === 'collection' ? (
        <EventSubTypeField
          source={'type'}
          label={'resources.payments.events.description'}
        />
      ) : (
        <EventPaymentSubTypeField
          source={'subType'}
          label={'resources.payments.events.description'}
        />
      )}
      <CurrencyField
        source="amount"
        label={'resources.payments.events.amount'}
        headerClassName={classes.headerRightWithoutIcon}
      />
      <TextField />
    </Datagrid>
  )
}
